import { CarouselControl as _CarouselControl, CarouselControlProps as _CarouselControlProps } from "reactstrap";

    export const CarouselControl = _CarouselControl;
    export type CarouselControlProps = _CarouselControlProps;
    